import { isGlobalAvailableProp } from "./lib";
export class PropsType {
    keys;
    keyList;
    constructor(keys) {
        this.keys = keys;
        this.keyList = Object.keys(keys);
    }
    extend(otherProps) {
        return new PropsType({
            ...this.keys,
            ...otherProps.keys,
        });
    }
    complete(completeKeys) {
        return new PropsType({
            ...this.keys,
            ...completeKeys,
        });
    }
    pickFrom(props) {
        const knownProps = {};
        if (typeof props !== "object") {
            throw new Error("PropsType.pickFrom() required a valid object");
        }
        for (const [prop, value] of Object.entries(props)) {
            if (isGlobalAvailableProp(prop) || this.keyList.includes(prop)) {
                knownProps[prop] = value;
            }
        }
        return knownProps;
    }
    omitFrom(props) {
        const knownProps = {};
        if (typeof props !== "object") {
            throw new Error("PropsType.omitFrom() required valid object");
        }
        for (const [prop, value] of Object.entries(props)) {
            if (!this.keyList.includes(prop)) {
                knownProps[prop] = value;
            }
        }
        return knownProps;
    }
    exclude(props) {
        const withoutExcludedKeys = { ...this.keys };
        const propNamesToExclude = props instanceof PropsType
            ? props.keyList
            : Array.isArray(props)
                ? props
                : Object.keys(props);
        for (const prop of propNamesToExclude) {
            if (prop in withoutExcludedKeys) {
                delete withoutExcludedKeys[prop];
            }
        }
        return new PropsType(withoutExcludedKeys);
    }
    shouldForwardProp = (prop) => {
        return !this.keyList.includes(prop);
    };
}
export default PropsType;
//# sourceMappingURL=data:application/json;base64,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